export type FrTranslationsType = typeof frTranslations;

export const frTranslations = {
  translation: {
    actions: 'Les actions',
    activate: 'Activer',
    active: 'Actifs',
    activity: 'Activité',
    allSchoolClasses: "Les classes de l'école",
    allSchoolGroups: "Les groupes de l'école",
    allSchoolStudents: "Les élèves de l'école",
    analysisBoard: 'Analyser une partie',
    answer: 'La réponse',
    assign: 'Attribuer',
    assignment: 'Travail de vérification',
    assignments: 'Travail de vérification',
    assignmentsPage: {
      addAssignment: "Création d'un travail de vérification",
      assignmentConsistOf: 'Un travail de vérification se compose de',
      callToActionCreate: 'Créez un travail de vérification',
      checkpointMessage:
        'Ce travail de vérification est un travail de certification. Bonne chance!',
      chooseClass: 'Choisissez une classe et nous vous proposerons des tâches appropriées',
      chooseGroup: 'Choisissez un groupe et nous vous proposerons des tâches appropriées',
      chooseTopics: "Choisissez des sujets (jusqu'à cinq)",
      createAssignment: 'Créer un affectation',
      createdList: 'Cette page affiche tous les affectations que vous avez créés.',
      deadlines: "Préciser l'heure de l'affectation",
      editAssignment: 'Modifier le travail de vérification',
      noAssignment: "Il n'y a pas encore de travail de vérification ici",
      noTopics: 'Aucun sujet trouvé pour cette classe',
      noTopicsForClass: 'Aucun sujet trouvé pour cette classe',
      noTopicsForGroup: 'Aucun sujet trouvé pour ce groupe',
      quarter: 'trimestrielle',
      taskHasFinished: 'Tâche accomplie',
      taskNotStarted: "La tâche n'a pas commencé",
    },
    attempt: 'Tentative',
    attempts: 'Tentatives',
    attention: 'Attention!',
    auth: {
      auth: 'Autorisation',
      changeEmail: "Modifier l'adresse email",
      changePassword: 'Changer le mot de passe',
      checkEmail: 'Vérifiez votre adresse email',
      confirmPassword: 'Confirmer le mot de passe',
      email: 'Adresse email',
      enter: 'Se connecter',
      enterEmail: 'Entrez votre adresse email',
      enterNewPassword: 'Entrez un nouveau mot de passe',
      errorOldPassword: "Le nouveau mot de passe doit être différent de l'ancien.",
      finishRegister: "Terminer l'inscription",
      forgotPassword: 'Mot de passe oublié?',
      incorrectLogin: 'Identifiant ou mot de passe incorrect',
      inviteSchoolAccepted: 'Vous avez accepté une invitation dans une nouvelle école!',
      inviteWrongCode: "L'invitation ou sa date d'expiration n'est pas valable",
      login: 'Se connecter',
      newPassword: 'Nouveau mot de passe',
      password: 'Mot de passe',
      passwordMinLength: 'Au moins 6 symboles',
      pleaseCheckEmail: 'Veuillez vérifier votre email',
      recoverPassword: 'Récupération du mot de passe',
      resetPassword: 'Réinitialiser le mot de passe',
      resetPasswordHelpMessage:
        'Vous pouvez également demander au coach de réinitialiser votre mot de passe.',
      resetPasswordMessage: 'Entrez votre adresse email pour réinitialiser votre mot de passe',
      schoolNotActive: "L'école n'est pas activée",
      schoolNotActiveCoach:
        "Votre école n'a pas accès au système Chess Class, veuillez contacter le coordinateur de votre école.",
      schoolNotActiveStudent:
        "Votre école n'a pas accès au système Chess Class, veuillez contacter votre professeur",
      schoolNotActiveSuperCoach:
        "Votre école n'a pas accès au système Chess Class, veuillez contacter l'équipe d'assistance {{supportEmail}}",
      send: 'Envoyer',
      sendConfirmation:
        'Nous vous avons envoyé un courriel contenant des instructions sur la manière de réinitialiser votre mot de passe.',
      updatePassword: 'Mise à jour du mot de passe',
      userInactive: "L'utilisateur avec cette adresse email a été bloqué",
      userNotActive: 'Utilisateur non activé',
      welcome: 'Bienvenue',
      welcomeToChess: 'Bienvenue <br />à <span class="text-primary">la classe d\'échecs!</span>',
    },
    author: 'Auteur',
    authors: 'Auteurs',
    back: 'Retour',
    birthDate: 'Date de naissance',
    boardEditorPage: {
      black: 'Noirs',
      blacksMove: 'Coup des Noirs',
      boardEditor: "Redacteur d'échiquier",
      castling: 'Le roque',
      clearTheBoard: "Effacer l'échiquier",
      nextMove: 'Le coup prochaine',
      startingPosition: 'Position de départ',
      turnTheBoardOver: "Retourner l'échiquier",
      white: 'Balncs',
      whitesMove: 'Coup des Blancs',
    },
    cancel: 'Annuler',
    cartoon: 'Caricature',
    chapter: 'Le thème',
    chapter_few: 'Les thèmes',
    chapter_many: 'des thèmes',
    chapter_other: 'des thèmes',
    chapters: 'Les thèmes',
    chaptersPage: {
      chapterList: 'Liste des thèmes',
      recommendationForCoach: 'Recommandation pour le coach',
    },
    choose: 'Sélectionnez',
    chooseLanguage: 'Sélectionnez une langue',
    class: 'Classe',
    classStudio: 'La salle de classe',
    classWork: 'Travail en classe',
    classes: 'Les classes',
    classesPage: {
      activateStudentMessage:
        "Êtes-vous sûr de vouloir donner accès au système à l'étudiant {{fullName}} ?",
      addClass: 'Ajouter une classe',
      addGroup: 'Ajouter un groupe',
      addStudent: 'Ajouter un étudiant',
      assignClass: 'Affecter une classe',
      assignGroup: 'Attribuer un groupe',
      backToClasses: 'Retour aux classes',
      backToGroups: 'Retour aux groupes',
      classLetter: 'Lettre de classe',
      classNumber: 'Numéro de classe',
      createClass: 'Créer une classe',
      createGroup: 'Créer un groupe',
      deactivateStudentMessage:
        "Êtes-vous sûr de vouloir suspendre l'accès au système pour l'élève {{nom complet}} ?",
      deleteClassMessage: 'Êtes-vous sûr de vouloir supprimer Classe {{grade}} "{{symbole}}" ?',
      deleteGroupMessage: 'Êtes-vous sûr de vouloir supprimer Groupe "{{symbole}}" ?',
      editClass: 'Modifier la classe',
      editCoach: 'Modifier le coach',
      editGroup: 'Modifier le groupe',
      editStudent: "Modifier l'étudiant",
      editTeacher: "Modifier l'enseignant",
      educationLanguage: "Langue de l'éducation",
      excludeFromClass: 'Supprimer de la classe',
      excludeFromGroup: "Supprimer d'un groupe",
      excludeFromSchool: "Supprimer de l'école",
      excludeStudentFromClass: "Êtes-vous sûr de vouloir retirer {{fullName}} d'une classe ?",
      excludeStudentFromGroup: 'Etes-vous sûr de vouloir retirer {{fullName}} du groupe ?',
      excludeStudentFromSchool: "Etes-vous sûr de vouloir retirer {{fullName}} de l'école ?",
      exportPdf: 'Exporter le PDF',
      groupNumber: 'Numéro de groupe',
      loginGenerate: 'Identifiant est généré par le champ "email"',
      myClasses: 'Mes classes',
      myGroups: 'Mes groupes',
      myStudents: 'Mes étudiants',
      noGrades: 'Aucune note est affichée',
      noHomework: "Il n'y a pas de devoirs",
      noIndependentWork: "Il n'y a pas de travail personnel",
      noStudents: "Il n'y a pas d'étudiants",
      resetPassword: 'Réinitialiser le mot de passe',
      studentPasswordGenerate:
        'Le mot de passe de l\'étudiant est généré par le champ "Date de naissance"',
      studentsCount: "Nombre d'étudiants",
      successActivateStudentMessage: "L'étudiant a été activé avec succès",
      successDeactivateStudentMessage: "L'étudiant a été désactivé avec succès",
      successExcludeStudentFromClassMessage: "L'étudiant a été retiré de la classe",
      successExcludeStudentFromGroupMessage: "L'étudiant a été retiré du groupe",
      successExcludeStudentFromSchoolMessage: "L'étudiant a été retiré avec succès de l'école",
      tableEmptyPlaceholder: 'Les étudiants apparaîtront ici après avoir rejoint votre école',
      unassigned: 'Non assigné',
    },
    clear: 'Effacer',
    coach: 'Enseignant',
    coaches: 'Enseignants',
    content: 'Contenu',
    copied: 'Copié',
    copy: 'Copie',
    correctLessonsCount: 'sont résolus correctement',
    create: 'Créer',
    date: 'Date',
    delete: 'Supprimer',
    edit: 'Modifier',
    email: 'Courriel',
    executionReport: "Rapport d'exécution",
    exercise: 'Exercice',
    'exerciseStatus.FAILED': 'Incorrect',
    'exerciseStatus.HOORAYGOODANSWER': 'Voilà la bonne réponse!',
    'exerciseStatus.NA': 'Non atteint',
    'exerciseStatus.SOLVED': 'Résolu',
    exercises: 'Exercices',
    exit: 'Quitter',
    filter: 'Filter',
    finish: 'Terminer',
    finishAt: "Date d'exécution",
    finishDate: 'Date limite',
    fio: 'Nom complet',
    firstName: 'Nom de famille',
    'gender.boy': 'Garçon',
    'gender.female': 'Femme',
    'gender.girl': 'Fille',
    'gender.male': 'Homme',
    'gender.title': 'Sexe',
    givenDate: 'Délivré',
    goBack: 'Retourner',
    grade: 'La note',
    grades: 'Les notes',
    group: 'Groupe',
    groupStudio: 'Studio du groupe',
    groups: 'Groupes',
    guideline: 'La ligne directrice',
    guidelines: 'Les lignes directrices',
    help: 'Aide',
    'helpModal.haveQuestions': 'Vous avez des questions?',
    'helpModal.helpText': 'En cas de questions, vous pouvez nous contacter par email',
    hide: 'Cacher',
    homeWorkIsDone: 'Devoirs terminés',
    homework: 'Devoir',
    homeworks: 'Devoirs',
    homeworksPage: {
      addHomework: 'Création de devoirs',
      attempts: 'essais',
      callToActionCreate: 'Créer un devoir à domicile',
      chooseClass: 'Sélectionnez une classe et nous vous proposerons des sujets appropriés',
      chooseGroup: 'Sélectionnez un groupe et nous vous proposerons des sujets appropriés',
      chooseTopic: 'Choisissez un thème',
      completed: 'Complété',
      correctTasksCount: '{{count}} / {{total}} tâches correctes',
      createHomework: 'Créer une tâche',
      createdList: 'Cette page affiche tous les devoirs que vous avez créés.',
      currentDeadLine: 'Date limite',
      deadlines: 'Préciser la date limite',
      deadlinesEdit: 'Modifier les délais',
      deleteHomeworkMessage: 'Voulez-vous vraiment supprimer "{{name}}" ?',
      editDueDate: 'Modifier la date limite',
      execute: 'Démarrage',
      homework: 'Les devoirs',
      homeworkConsistOf: 'Les devoirs consistent en',
      issued: 'Émis',
      newDeadLine: 'Nouvelle date limite',
      noTopicsForClass: "Aucun thème n'a été trouvé pour cette classe",
      noTopicsForGroup: "Aucun thème n'a été trouvé pour ce groupe",
      possible: '/ {{count}} possible',
      startHomeworkMessage: 'Voulez-vous vraiment commencer vos devoirs?',
      startIndependentMessage: 'Voulez-vous vraiment commencer le travail personnel?',
      successEditDueDateChange: "La date limite de l'affectation a été modifiée avec succès",
      task: 'Tâche',
      tasks: 'Tâches',
      toAllStudents: 'A tous les étudiants',
      usedAttemptsCount: 'Nombre de tentatives utilisées',
      watchChapter: 'Voir le thème',
    },
    iin: "IIN (Numéro d'identification individuel)",
    independentWork: 'Travail personnel',
    independentWorks: 'Travaux personnels',
    invalidEmail: 'Email invalide',
    'language.en': 'Anglais',
    'language.kz': 'Kazakh',
    'language.ru': 'Russe',
    lastName: 'Nom',
    lesson: 'Leçons',
    lessons: 'Leçons',
    lessonsPage: {
      firstLevel: '1st level',
      fourthLevel: '4th level',
      secondLevel: '2nd level',
      thirdLevel: '3rd level',
      topicsMessage: "C'est ici que vous pouvez voir les thèmes de leçons que vous avez complétés.",
      welcomeToChess: 'Salut! Bienvenue <br />aux Chess <span class="text-primary">Class</span>',
    },
    login: 'Se connecter',
    materials: 'Matériaux additionnels',
    messages: {
      birthDateShouldNotBeInTheFuture: 'La date de naissance ne doit pas être dans le futur',
      chapterNotSelected: 'Chapter is not selected',
      dueDateCannotBeEarlierThanStartDate:
        'La date limite ne peut être antérieure à la date de début',

      dueDateCannotBeEarlierThanTheCurrentDate:
        'La date limite ne peut être antérieure à la date du jour',
      error: 'Il y a eu une erreur, réessayez',
      errorEmailAlreadyUsed: "L'adresse email est déjà utilisée",
      errorPostReview: "Échec de l'enregistrement de l'avis",
      errorProfileNotFound: 'Profil introuvable',
      errorUserNotFound: 'Utilisateur introuvable',
      studentNotSelected: 'Student not selected',
      successAdminInvite: "L'invitation au personnel a été envoyée",
      successAssignmentCreate: 'Le travail de vérification a été créé avec succès',
      successAssignmentDelete: 'Le travail de vérification a été supprimé avec succès !',
      successAssignmentEdit: 'Le travail de contrôle a été modifié avec succès',
      successAuthorDelete: "L'auteur a été supprimé avec succès !",
      successAuthorEdit: "L'auteur a été modifié avec succès",
      successChapterCreate: 'Le thème a été créé avec succès',
      successChapterDelete: 'Le thème a été supprimé avec succès !',
      successChapterEdit: 'Le thème a été modifié avec succès',
      successChapterGive: 'Le thème a été délivré avec succès',
      successClassCreate: 'La classe a été créée avec succès',
      successClassDelete: 'La classe a été supprimée avec succès',
      successClassEdit: 'La classe a été modifiée avec succès',
      successCoachDelete: "L'enseignant a été supprimé avec succès!",
      successCoachEdit: "L'enseignant a été modifié avec succès!",
      successExerciseDelete: 'La tâche a été supprimée avec succès !',
      successExerciseGroupDelete: "Le groupe d'exercices a été supprimé",
      successExerciseGroupEdit: "Le groupe d'exercice a été modifié",
      successGroupCreate: 'Le groupe a été créé avec succès',
      successGroupDelete: 'Le groupe a été supprimé avec succès',
      successGroupEdit: 'Le groupe a été modifié avec succès',
      successHomeworkCreate: 'Le devoir a été créé avec succès!',
      successHomeworkDelete: 'Le devoir a été supprimé avec succès!',
      successPasswordInvoke:
        'Un courriel de réinitialisation de mot de passe a été envoyé à votre adresse email.',
      successPasswordUpdate: 'Mot de passe a été mis à jour avec succès',
      successProfileEdit: 'Profil a été mis à jour avec succès',
      successRegister: 'Enregistrement réussi',
      successReviewPost: 'Le feedback a été enregistré avec succès',
      successSchoolDelete: "L'école a été supprimée avec succès",
      successStaffDelete: 'Le personnel a été modifié avec succès',
      successStaffEdit: 'Le personnel a été modifié avec succès',
      successStudentAddToClass: "L'étudiant a été ajouté avec succès à une classe",
      successStudentAddToGroup: "L'étudiant a été ajouté avec succès à un groupe",
      successStudentCreate: "L'étudiant a été créé avec succès",
      successStudentEdit: "L'étudiant a été modifié avec succès",
      successVideoDelete: 'La vidéo a été supprimée avec succès',
      successVideoEdit: 'La vidéo a été modifiée avec succès',
      successVideoFileDelete: 'Le fichier vidéo a été supprimé avec succès',
      successVideoFileEdit: 'Le fichier vidéo a été modifié avec succès',
      successVideoFileUpload:
        'Le fichier vidéo a été téléchargé avec succès, il sera disponible pour la sélection dans quelques instants.',
      warningAssignmentConsistOf: 'Le travail de verification doit comporter au moins un problème.',
      warningHomeworkConsistOf: 'Le devoir doit contenir au moins 1 tâche/test',
      warningSession: 'Expiré ou mauvais format, réessayer plus tard',
      warningStudentEmail: 'Un étudiant ayant cette adresse email a déjà été inscrit.',
    },
    middleName: 'Patronyme',
    modals: {
      exerciseAttemptsTooltipDescription:
        'Le nombre total de tentatives peut être utilisé pour une tâche ou réparti entre plusieurs tâches à votre discrétion. Utilisez les tentatives à bon escient pour résoudre chaque problème aussi efficacement que possible.',
      exerciseAttemptsTooltipTitle: 'Vous avez des tentatives pour résoudre les problèmes.',
      exerciseHelpText:
        'La plupart des tentatives ont été utilisées. Essayez de passer à d’autres tâches pour améliorer votre score et augmenter vos chances de réussite.',
      goodLuck: 'Bonne chance!',
      incorrectAnswer: 'Faux',
      mustAnswerAllQuestions: 'Il faut répondre à toutes les questions!',
      tryAgain: 'Essayer à nouveau',
    },
    more: 'Plus de détails',
    newestFirst: "Les nouveaux d'abord",
    next: 'Plus loin',
    no: 'Non',
    noResult: 'Aucun résultat trouvé',
    notFoundResult: {
      chooseClass: 'Sélectionnez une classe',
      chooseGroup: 'Sélectionner un groupe',
      createClass: 'Créer une classe',
      createClassHelpMessage: "Vous pouvez créer une nouvelle classe dans l'onglet classes",
      createGroup: 'Créez un groupe',
      createGroupHelpMessage: "Vous pouvez créer un nouveau groupe dans l'onglet Groupes",
      goBackToAssignments: "Retourner à l'onglet Toutes les travaux de verification",
      goBackToHomeworks: "Retourner à l'onglet Toutes les devoirs",
      noAssignment: 'Le travail introuvable',
      noChapterExercises: "Les tâches n'ont pas été ajoutées à ce thème",
      noChapters: 'Aucun sujet trouvé',
      noCoach: 'Enseignant introuvable',
      noHomework: 'Les devoirs introuvables',
      noHomeworkExercises: "Aucune tâche n'a été trouvée dans les devoirs.",
      noLessons: 'Aucune leçon trouvée',
      noMaterials: "Aucun matériel additionnel n'a été ajouté à ce sujet.",
      noStudent: 'Étudiant non trouvé',
    },
    oldestFirst: 'Ancienne première',
    passed: 'Accomplie',
    pause: 'Suspendre',
    phone: 'Téléphone',
    phoneNumber: 'Numéro de téléphone',
    problem: 'Tâche',
    problem_few: 'Tâches',
    problem_many: 'Tâches',
    problem_other: 'Tâches',
    problems: 'Tâches',
    proceed: 'Démarrage',
    profile: 'Profil',
    profilePage: {
      birthDate: 'Date de naissance',
      email: 'Email',
      emailPlaceholder: 'Saisissez votre adresse email',
      firstName: 'Nom',
      gender: 'Sexe',
      genderPlaceholder: 'Choisissez un sexe',
      iin: 'IIN',
      lastName: 'Nom',
      loginAndPassword: 'Identifiant et mot de passe',
      loginHelpText: 'L\'identifiant est généré par le champ "email".',
      middleName: 'Patronyme',
      passwordRepeatError: 'Ce mot de passe a déjà été utilisé, veuillez en créer un nouveau.',
      personalInfo: 'Informations personnelles',
      phone: 'Téléphone',
      phonePlaceholder: 'Entrez votre numéro de téléphone',
      profileSettings: 'Paramètres du profil',
      schoolAndCoach: "L'école et le coach",
      schoolAndTeacher: "L'école et l'enseignant",
      withoutCoach: 'Sans coach',
      withoutCoachHelpText: "Vous n'êtes pas encore connecté à un coach",
      withoutTeacher: 'Sans enseignant',
      withoutTeacherHelpText: "Vous n'êtes pas encore connecté à un enseignant",
    },
    report: 'Rapport',
    requiredField: 'Ce champ est obligatoire',
    result: 'Résultat',
    results: 'Résultats',
    review: {
      review: 'Évaluer',
      reviewChapter: 'Veuillez évaluer ce thème',
      reviewExercise: 'Veuillez évaluer cette tâche',
      reviewLesson: 'Veuillez évaluer cette leçon',
      reviewTest: 'Évaluer les questions du travail personnel que vous venez de réaliser',
      reviewVideo: 'Évaluez la vidéo que vous avez regardée',
      tellUsMoreDetails: 'Dites-nous en plus à son sujet',
      thisWillHelpUpToImprove: "Cela nous aidera à l'améliorer",
      whatDidYouLike: 'Dites-nous ce qui vous a plu',
      whatYouDidntLike: "Dites-nous ce que vous n'avez pas aimé?",
    },
    save: 'Conserver',
    school: 'École',
    schools: 'Écoles',
    search: 'Rechercher',
    searchHelpText: 'Essayez de modifier votre recherche',
    seeDetails: 'Aller à',
    selfWorkIsDone: 'Travail personnel terminé',
    show: 'Montrer',
    solution: 'La solution',
    solvedCount: 'ont réalisé',
    startAt: "Date d'émission",
    startDate: 'Date de démarrage',
    status: 'Statut',
    statuses: {
      ACTIVE: 'Actif',
      ALL: 'All',
      AVAILABLE: 'Disponible',
      DELETED: 'Supprimé',
      DISABLED: 'Bloqué',
      DRAFT: 'Le brouillon',
      FAILED: 'Incorrecte',
      FINISHED: 'Complété',
      GIVEN: 'Émis',
      INACTIVE: 'Inactif',
      INVITED: 'Invité',
      ISSUED: 'Émis',
      NA: 'Non accompli',
      NEW: 'Nouveau',
      NOT_AVAILABLE: 'Pas disponible',
      NOT_INVITED: 'Sans invitation',
      NOT_ISSUED: 'Non délivré',
      NOT_PASSED: 'Non réussi',
      PAUSED: 'En pause',
      RÉUSSI: 'Réussi',
      SOLVED: 'Résolu',
    },
    student: 'Étudiant',
    studentDetails: "Détails de l'étudiant",
    studentProfile: 'Profil étudiant',
    student_few: 'Étudiant',
    student_many: 'Étudiants',
    student_other: 'Étudiants',
    students: 'Étudiants',
    studio: 'Le studio',
    studiosPage: {
      alertEndLesson: 'Voulez-vous vraiment terminer la leçon?',
      attemptsLeft: 'Tentatives restantes',
      available: 'Disponible',
      chooseAnswer: 'Sélectionner une réponse',
      chooseClass: 'Sélectionner une classe',
      chooseGroup: 'Sélectionner un groupe',
      demonstrationsStudio: 'Studio de démonstration',
      endLesson: 'Terminer la leçon',
      findTheBestMoveFor: 'Trouver le meilleur coup pour',
      findTheBestMoveForBlack: 'Trouver le meilleur coup pour les Noirs',
      findTheBestMoveForWhite: 'Trouver le meilleur coup pour les Blancs',
      giveHomeWork: 'Délivrer des devoirs',
      given: 'Délivré',
      hideAnswer: 'Masquer la réponse',
      hideSolution: 'Cacher la réponse',
      showAnswer: 'Montrer la réponse',
      showSolution: 'Montrer la solution',
      studioView: 'Démonstration en studio de classe',
      viewMoves: 'Voir les coups',
      weWillSuggest: 'Nous vous proposerons un thème et des exercices adaptés.',
      yourMove: 'Votre coup',
    },
    successPasswordResetMessage: 'Réinitialisation du mot de passe réussie',
    superCoach: 'Coordinateur',
    superCoaches: 'Coordinateurs',
    teacher: 'Enseignant',
    teachers: 'Enseignants',
    test: 'Test',
    tests: 'Tests',
    time: 'Temps',
    title: 'Titre',
    total: 'Total',
    tryAgainLater: 'Réessayer plus tard',
    type: 'Type',
    understand: "D'accord",
    videofiles: 'Fichiers vidéo',
    videolesson: 'Leçon vidéo',
    yes: 'Oui',
    youHaveMoreAttempts:
      'Il vous reste des tentatives, vous pouvez revenir et améliorer votre score.',
    yourResult: 'Votre résultat',
  },
};
